/*
 * Fence detection (Q21): Enter inside a fenced code block always inserts a newline, whatever the
 * send key is, because a person typing code presses Enter for a line and nothing else. "Inside"
 * follows CommonMark's fences — an opening run of three or more backticks or tildes at the start
 * of a line, closed by a run of the same character at least as long — and the line the caret is
 * on counts when it is the opener: Enter after typing ``` opens the block, it does not send it.
 */

const FENCE = /^ {0,3}(`{3,}|~{3,})(.*)$/

export function caretInFencedBlock(text: string, caret: number): boolean {
	const lines = text.slice(0, caret).split("\n")
	let open: { ch: string; len: number } | null = null
	for (const line of lines) {
		const m = FENCE.exec(line)
		if (m === null || m[1] === undefined || m[2] === undefined) continue
		const run = m[1]
		const ch = run.charAt(0)
		const info = m[2]
		if (open === null) {
			// A backtick fence's info string may not contain a backtick; `` ```a`b `` is inline code.
			if (ch === "~" || !info.includes("`")) open = { ch, len: run.length }
		} else if (ch === open.ch && run.length >= open.len && info.trim() === "") {
			open = null
		}
	}
	return open !== null
}
